module.exports = __webpack_public_path__ + "static/media/lar.bb54656e.png";